/*
 * Copyright (c) 2020. Sonrai Analytics Limited
 * Developed by Warren Dowey
 */

export class ProjectImageModel {
  private _projectImagesUuid?: string;
  private _projectSlug?: string;
  private _s3Url?: string;

  constructor(projectImagesUuid?: string, projectSlug?: string, s3Url?: string) {
    this._projectImagesUuid = projectImagesUuid;
    this._projectSlug = projectSlug;
    this._s3Url = s3Url;
  }

  get projectImagesUuid(): string {
    return this._projectImagesUuid;
  }

  set projectImagesUuid(value: string) {
    this._projectImagesUuid = value;
  }

  get projectSlug(): string {
    return this._projectSlug;
  }

  set projectSlug(value: string) {
    this._projectSlug = value;
  }

  get s3Url(): string {
    return this._s3Url;
  }

  set s3Url(value: string) {
    this._s3Url = value;
  }

  toJson(): Object {
    const object = {
      project_images_uuid: this.projectImagesUuid,
      project_slug: this.projectSlug,
      s3_url: this.s3Url,
    };
    Object.keys(object).forEach((k) => !object[k] && object[k] !== undefined && delete object[k]);
    return object;
  }

  fromJson(input: any): ProjectImageModel {
    return new ProjectImageModel(
      input['project_images_uuid'],
      input['project_slug'],
      input['s3_url']
    );
  }
}
